import { OAuthViewModel } from '@apis/model';
import { OAuthResponse } from '@ul/api/lib/models/OAuthResponse';
import { toCaptchaViewModel, toOtpViewModel } from '@apis/responseTransformer';
import { toUserInfoModel } from '@apis/responseTransformer/toUserInfoModel';

export const toOAuthViewModel = (oauthResponse: OAuthResponse): OAuthViewModel => {
    const { success, responseCode, socialClaims } = oauthResponse;
    return {
        responseCode,
        success,
        captchaViewModel: toCaptchaViewModel(oauthResponse),
        otpViewModel: toOtpViewModel(oauthResponse),
        userInfo: toUserInfoModel(oauthResponse),
        socialClaims,
    };
};
